module.exports = __webpack_public_path__ + "img/slide1_2.af61cf59.png";